//* 장례식장정보 수정 페이지
import { FC, useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { useFuneralHomeInfoHook } from '@shared/api/funeralHomeInfo/funeralHomeInfo.hook';
import {
  FuneralHomeInfoListStateSelector,
  funeralHomeInfoStateSelectorFamily,
} from '@shared/api/funeralHomeInfo/funeralHomeInfo.selector';
import { Loading } from '@shared/components/Loading';
import { FuneralHomeInfoEditor } from '@shared/containers/FuneralHomeInfoEditor/FuneralHomeInfoEditor';
import { useParams } from 'react-router-dom';

import { AdminFuneralHomeDnAssignPanel } from '../components/AdminFuneralHomeDnAssignPanel';
import { useAdminTitleHook } from '../hooks/useAdminTitleHook';

const AdminFuneralHomeInfoEditPage: FC = function AdminFuneralHomeInfoEditPage() {
  useAdminTitleHook('장례식장정보 수정');

  const { funeralHomeInfoId } = useParams();

  const funeralHomeInfoListState = useRecoilValue(FuneralHomeInfoListStateSelector);

  //* 추가정보 사진(image)까지 populate 된 단건.
  //* 목록에는 populate가 없어서 사진이 id 문자열로 오는데, 그 상태로 저장하면
  //* 사진 없음으로 취급돼 기존 사진이 지워진다 → 편집은 반드시 단건으로 한다.
  useFuneralHomeInfoHook(`${funeralHomeInfoId}`);
  const funeralHomeInfoState = useRecoilValue(
    funeralHomeInfoStateSelectorFamily(`${funeralHomeInfoId}`),
  );

  const listItem = useMemo(() => {
    return funeralHomeInfoListState.data?.find((item) => item._id === funeralHomeInfoId);
  }, [funeralHomeInfoId, funeralHomeInfoListState.data]);

  //* 단건 조회가 실패하는 서버(추가정보 미반영 = StrictPopulateError)에서는 목록으로 폴백
  const editTarget = useMemo(() => {
    if (funeralHomeInfoState.data) return funeralHomeInfoState.data;
    if (funeralHomeInfoState.status === 'error') return listItem;
    return undefined;
  }, [funeralHomeInfoState.data, funeralHomeInfoState.status, listItem]);

  const render = useMemo(() => {
    if (!editTarget) {
      return (
        <div className="center-box h-screen-15">
          <Loading />
        </div>
      );
    }

    return (
      <div className="space-y-4">
        <h3 className="bugo-h1">{editTarget.name}</h3>
        <FuneralHomeInfoEditor funeralHomeInfo={editTarget} />
        <div className="space-y-2 rounded-md border border-gray-200 p-3">
          <h4 className="text-15 font-bold">부고브랜드별 꽃집 연결 (DN)</h4>
          <AdminFuneralHomeDnAssignPanel funeralHomeInfoId={editTarget._id} />
        </div>
      </div>
    );
  }, [editTarget]);

  return <div className="p-4">{render}</div>;
};

export default AdminFuneralHomeInfoEditPage;
